import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function Offers() {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOffer, setSelectedOffer] = useState(null);

    useEffect(() => {
        console.log('Fetching offers for Offers');
        axios
            .get('https://laravel-api.petra-ms.com/api/offers')
            .then(response => {
                console.log('API Response:', response.data);
                if (response.data.success) {
                    setOffers(response.data.data);
                } else {
                    setError('API returned success: false');
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching offers:', error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    const openModal = (offer) => {
        setSelectedOffer(offer);
    };

    const closeModal = () => {
        setSelectedOffer(null);
    };

    if (loading) {
        return <div className="text-center py-10">Loading...</div>;
    }

    if (error) {
        return <div className="text-center py-10 text-red-500">Error: {error}</div>;
    }

    if (offers.length === 0) {
        return <div className="text-center py-10">No offers available.</div>;
    }

    const showData = offers.map((el) => (
        <div
            key={el.id}
            className="relative bg-black text-white rounded-lg overflow-hidden shadow-[0_0_10px_#0000001a] hover:shadow-lg transition-shadow duration-300 cursor-pointer"
            onClick={() => openModal(el)}
        >
            <img
                src={`https://laravel-api.petra-ms.com/storage/app/public/${el.offer_img}`}
                alt={`Offer ${el.offer_name}`}
                className="w-full h-[300px] object-cover"
                onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
            />
        </div>
    ));

    return (
        <>
            <section className="py-10">
                <div className="container mx-auto">
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold">Offers</h1>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {showData}
                    </div>
                </div>
            </section>

            {selectedOffer && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-3xl w-full mx-4 relative">
                        <button
                            onClick={closeModal}
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
                        >
                            &times;
                        </button>
                        <img
                            src={`https://laravel-api.petra-ms.com/storage/app/public/${selectedOffer.offer_img}`}
                            alt={`Offer ${selectedOffer.offer_name}`}
                            className="w-full h-[500px] object-contain rounded-lg mb-4"
                            onError={(e) => console.log(`Failed to load modal image: ${e.target.src}`)}
                        />
                        <div className="text-center">
                            <Link
                                to={`/items-details/${selectedOffer.id}`}
                                className="inline-block bg-[#20BCB4] text-white py-3 px-8 rounded-lg font-bold hover:bg-[#1a9c95] hover:scale-105 transition-transform duration-200 shadow-[0_4px_10px_rgba(0,0,0,0.2)]"
                                onClick={closeModal}
                            >
                                Go to Details
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}